import React, { memo } from 'react';
// Memoize the Hero component since it's critical for LCP
const Hero = memo(() => {
  const handlePurchaseClick = () => {
    if (window.fbq) window.fbq('track', 'AddToCart', {
      content_name: '7 Cenas Latinas en 30 Minutos',
      content_type: 'product',
      value: 7.0,
      currency: 'USD'
    });
  };
  return <section className="py-12 md:py-20 bg-gradient-to-b from-amber-50 to-white" data-id="element-162">
      <div className="container mx-auto px-4 md:px-8" data-id="element-163">
        <div className="flex flex-col md:flex-row items-center" data-id="element-164">
          <div className="w-full md:w-1/2 mb-8 md:mb-0 md:pr-8" data-id="element-165">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-custom-brown mb-4 leading-tight" data-id="element-166">
              Cocina rico y rápido: 7 cenas latinas en 30 minutos
            </h1>
            <h2 className="text-lg md:text-xl text-gray-700 mb-6" data-id="element-167">
              El método exprés que transforma tus noches de cansancio en
              momentos deliciosos y organizados, sin gastar de más.
            </h2>
            <div className="flex items-center mb-6" data-id="element-168">
              <div className="flex text-amber-500" data-id="element-169">
                <span data-id="element-170">⭐⭐⭐⭐⭐</span>
              </div>
              <p className="ml-2 text-sm text-gray-600" data-id="element-171">
                "Más de 1.200 familias ya disfrutan de este sistema"
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center" data-id="element-172">
              <a href="https://pay.hotmart.com/W101891326K?checkoutMode=10" className="bg-white text-custom-brown hover:bg-custom-brown hover:text-white border border-custom-brown font-bold py-3 px-8 rounded-lg text-lg transition duration-300 shadow-lg" onClick={handlePurchaseClick} data-id="element-173">
                Quiero mis 7 cenas rápidas - $7.00
              </a>
            </div>
            <p className="mt-3 text-custom-brown font-medium text-center sm:text-left" data-id="element-174">
              <del className="text-gray-500" data-id="element-175">$83</del> - ahorras $77
            </p>
          </div>
          <div className="w-full md:w-1/2" data-id="element-176">
            <div className="img-container aspect-ratio-4-3 shadow-xl rounded-lg" data-id="element-177">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1rQotE4xP1TzE5mt27p9r7/POrtada_Caro.jpg" alt="7 Cenas Latinas en 30 Minutos – Método Exprés Latino" className="img-content" width="600" height="450" fetchpriority="high" loading="eager" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://via.placeholder.com/600x450/f5f5f5/a97142?text=7+Cenas+Latinas';
            }} data-id="element-178" />
            </div>
          </div>
        </div>
      </div>
    </section>;
});
export default Hero;